export default __webpack_public_path__ + "static/media/Fliesenarbeiten.c2dd6129.jpg";